import { ApexAxisChartSeries } from 'ng-apexcharts'

export interface BlockChart {
    series: ApexAxisChartSeries
    categories: string[]
    colors?: string[]
}

export interface NationalHeadline {
    publishedBays: number
    activeBays: number
    medianPriceRands: number
    avgContractMonths: number
    avgBaysPerContract: number
    totalContractValueRands: number
    publishedBuildings: number
}

export interface CityRow {
    city: string
    buildings: number
    totalBays: number
    activeBays: number
    medianPrice: number
    meanPrice: number
    p25Price: number
    p75Price: number
    avgContractMonths: number
    avgBaysPerContract: number
    avgContractValue: number
    demandIndex: number
    sampleSizeParkings: number
    sampleSizeSubscriptions: number
    searchCount: number
    leadCount: number
}

export interface SuburbRow {
    suburb: string
    city: string
    medianPrice: number
    meanPrice: number
    bayCount: number
    parkingCount: number
}

export interface AmenityPremium {
    amenity: string
    label: string
    withPrice: number
    withoutPrice: number
    premiumPct: number
    withCount: number
    withoutCount: number
}

export interface PriceBand {
    label: string
    min: number
    max: number
}

export interface PriceBandRow {
    city: string
    bands: number[]
}

export interface AskingVsAchieved {
    city: string
    askingMedian: number
    achievedMedian: number
    discountPct: number
    sampleSize: number
}

export interface LeadReasonRow {
    city: string
    tooFar: number
    tooExpensive: number
    requirementsNotMet: number
    fullyBooked: number
    other: number
    total: number
}

export interface MonthlyUptake {
    month: string
    label: string
    newContracts: number
    baysContracted: number
    medianPrice: number
}

export interface CityMonthlyUptake {
    city: string
    months: MonthlyUptake[]
}

export interface TermMixRow {
    city: string
    fixedTerm: number
    monthToMonth: number
    allocated: number
    total: number
}

export interface RenewalRow {
    city: string
    renewed: number
    notRenewed: number
    pending: number
    total: number
    renewalRate: number
}

export interface NonRenewalReasonRow {
    reason: string
    label: string
    count: number
}

export const PRICE_BANDS: PriceBand[] = [
    { label: 'Under R500', min: 0, max: 50000 },
    { label: 'R500 - R1,000', min: 50000, max: 100000 },
    { label: 'R1,000 - R1,500', min: 100000, max: 150000 },
    { label: 'R1,500 - R2,000', min: 150000, max: 200000 },
    { label: 'R2,000+', min: 200000, max: Infinity },
]

export const CHART_PALETTE = [
    '#3e8bff', '#4bd181', '#f59e0b', '#ef4444', '#a78bfa',
    '#14b8a6', '#f97316', '#6366f1', '#ec4899', '#84cc16',
    '#06b6d4', '#d946ef',
]
